import { NgModule } from '@angular/core';
import { DurationFormatPipe } from './duration-format-pipe';

@NgModule({
   declarations: [DurationFormatPipe],
   exports: [DurationFormatPipe],
})
export class DurationFormatPipeModule {}
